import styled from 'styled-components';

export const RadioLabel = styled.label`
  position: relative;
  padding-left: ${props => props.theme.space['3.5']};
  cursor: pointer;
  display: flex;
  flex-direction: row;

  &:not(:first-child) {
    margin-top: ${props => props.theme.space.s5};
  }
`;

export const RadioInput = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
`;

export const RadioCircle = styled.span<{ isActive: boolean }>`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  height: 2rem;
  width: 2rem;
  border: ${props => props.theme.borderWidths.small} solid ${props => props.theme.colors.capsuleBlue50};
  border-radius: ${props => props.theme.radii.circle};

  &:after {
    content: '';
    position: absolute;
    display: ${props => (props.isActive ? 'block' : 'none')};
    top: 0.2rem;
    left: 0.2rem;
    width: 1.4rem;
    height: 1.4rem;
    border-radius: ${props => props.theme.radii.circle};
    background: ${props => props.theme.colors.capsuleBlue50};
  }
`;
